import { GetterTree } from "vuex";
import { GuardTourState, GuardTour } from "./types";
import { RootState } from "@/store/types";

export const getters: GetterTree<GuardTourState, RootState> = {
	/** Tours Setup */
	getGuardTours: (state: GuardTourState): GuardTour[] => {
		return state.guardTours.filter(t => t.guardTourTypeId === state.filterTourTypeId);
	},
	getGuardTour: (state: GuardTourState) => (guardTourId: number): GuardTour => {
		let tour = state.guardTours.find((guardTour: GuardTour) => guardTour.guardTourId == guardTourId);
		if (tour) {
			tour.guardTourSteps = tour.guardTourSteps ?? [];
		}
		return tour;
	},
}